const appUrl = {
  // baseUrl:'http://192.168.4.86:3003/',
  // fileBaseUrl:'http://192.168.4.94:3003/',
  // baseUrl:'http://192.168.4.192:3012/',
  // baseUrl:'http://20.212.227.60:3012/',

  // Before ssl (No using now)
  // BASE_URL: "http://20.212.227.60:3020/",
  // baseUrlImg: "http://20.212.227.60:3020/",

  // baseUrl:"${BASE_URL}api/v2/",
  adminLogin: "user/login",
  // getStats: 'parkingHistory/checkInCheckOutState?fromDate="2023-03-12"&toDate="2023-03-14"',
  getPassengersList: "api/web/user/userByType",
  updateUserStatus: "api/web/user/activeStatus",
  updateDriverDocumentStatus: "api/web/user/documentStatus",
  getUserById: "api/web/user/userProfile",
  // getList: 'parkingHistory/all?fromDate="2023-03-12"&toDate="2023-03-14"',
  generateTickets: "QR/generate",

  // fahad New
  // Fixed with SSl for successful handshake between client and server
  //  BASE_URL: "https://qa-car-parking-api.appinsnap.com/api/v2/",
  // //  BASE_URL: "https://api-carparking.appinsnap.com/",
  //  baseUrlImg: "https://qa-car-parking-api.appinsnap.com/api/v2/",

// LIve
  BASE_URL: "https://api-carparking.appinsnap.com/api/v2/",
//   //  BASE_URL: "https://api-carparking.appinsnap.com/",
   baseUrlImg: "https://api-carparking.appinsnap.com/api/v2/",
  // Fahad
  // New deployment 20 jan with exemption and UI upgrades
  // BASE_URL: "https://api-carparking.appinsnap.com/",
  // baseUrlImg: "https://api-carparking.appinsnap.com/",

  // Local

  
  // BASE_URL: "http://localhost:3020/",
  // baseUrlImg: "http://localhost:3020/",
};
export default appUrl;
